import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="bg-light">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-9 col-xl-8">
            <div className="card shadow-sm border-0">
              <div className="card-body p-4 p-md-5">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-start gap-3 mb-4">
                  <div>
                    <h1 className="h3 mb-2">Privacy Policy</h1>
                    <p className="text-muted mb-0">
                      This policy explains how we collect and use information on this platform.
                    </p>
                  </div>
                  <div className="text-md-end">
                    <span className="badge text-bg-secondary">Last updated: 26 February 2026</span>
                  </div>
                </div>

                <hr className="my-4" />

                <h2 className="h5">Who we are</h2>
                <p className="mb-4">
                  We provide a platform for Neuro counsellors and therapists to create profiles and receive enquiries from
                  users. This Privacy Policy explains what we collect, why we collect it, and how it is handled.
                </p>

                <h2 className="h5">Information we collect</h2>
                <div className="mb-4">
                  <h3 className="h6 mb-2">Counsellor profile information</h3>
                  <p className="mb-2">
                    When a counsellor creates or updates a profile, we collect information that is displayed on the
                    profile and used to help users understand the counsellor’s background and services, such as:
                  </p>
                  <ul className="mb-0">
                    <li>Name and professional title</li>
                    <li>Practice or service details</li>
                    <li>Licences, registrations, and awarding bodies</li>
                    <li>Qualifications, accreditations, and relevant certifications</li>
                    <li>Professional awards (if provided)</li>
                    <li>Contact and location details provided for the profile</li>
                  </ul>
                </div>

                <div className="mb-4">
                  <h3 className="h6 mb-2">Enquiries and messages</h3>
                  <p className="mb-0">
                    If a user sends an enquiry through the platform, we store the enquiry content and related details so
                    the counsellor or therapist can read and respond within the app. This may include the message text and
                    any contact details the user chooses to include.
                  </p>
                </div>

                <div className="mb-4">
                  <h3 className="h6 mb-2">Analytics and technical data</h3>
                  <p className="mb-2">
                    We collect basic technical information to understand how the platform is used, improve reliability,
                    and monitor performance.
                  </p>
                  <ul className="mb-0">
                    <li>
                      IP addresses may be collected for analytics but are stored in a hashed form.
                    </li>
                    <li>Device and browser information (for example, browser type and operating system)</li>
                    <li>Usage events (for example, page views and feature usage)</li>
                  </ul>
                </div>

                <h2 className="h5">How we use your information</h2>
                <ul className="mb-4">
                  <li>To create and display counsellor profiles</li>
                  <li>To allow users to make enquiries and allow therapists to read enquiries in the app</li>
                  <li>To provide, maintain, and improve the platform</li>
                  <li>To monitor security and prevent misuse</li>
                  <li>To understand usage trends using analytics (including hashed IP data)</li>
                </ul>

                <h2 className="h5">What we do not use your information for</h2>
                <p className="mb-4">
                  We do not sell personal information. Profile data is used to support the profile and service discovery
                  experience and for operating the platform.
                </p>

                <h2 className="h5">Sharing your information</h2>
                <p className="mb-2">
                  We only share information in limited situations:
                </p>
                <ul className="mb-4">
                  <li>
                    <strong>With other users:</strong> counsellor profile details are visible as part of the platform.
                  </li>
                  <li>
                    <strong>With service providers:</strong> trusted providers may process data on our behalf for hosting,
                    analytics, and security.
                  </li>
                  <li>
                    <strong>For legal reasons:</strong> if required to comply with the law or protect rights, safety, and
                    security.
                  </li>
                </ul>

                <h2 className="h5">Data retention</h2>
                <p className="mb-4">
                  We keep profile information for as long as the counsellor maintains an account or as needed to operate
                  the service. Enquiries are stored so therapists can read them within the app and may be retained while
                  accounts remain active, unless deletion is requested where applicable.
                </p>

                <h2 className="h5">Security</h2>
                <p className="mb-4">
                  We use reasonable technical and organisational measures to protect information. No system is completely
                  secure, but we work to prevent unauthorised access, disclosure, and misuse.
                </p>

                <h2 className="h5">Your rights and choices</h2>
                <ul className="mb-4">
                  <li>Request access to your information</li>
                  <li>Request corrections to profile details</li>
                  <li>Request deletion where applicable</li>
                  <li>Object to or restrict certain processing where applicable</li>
                </ul>

                <h2 className="h5">Contact</h2>
                <p className="mb-0">
                  If you have questions about this Privacy Policy or want to make a request, contact us using the support
                  details provided in the app or on our website.
                </p>

                <hr className="my-4" />

                <p className="text-muted small mb-0">
                  This page is provided for general information and should be reviewed to ensure it matches your exact
                  product behaviour and legal requirements.
                </p>
              </div>
            </div>

            <div className="text-center mt-4">
              <a className="btn btn-outline-secondary" href="/" role="button">
                Back to home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}